const abbreviations = ['Dr.', 'Dra.'];

const reducerName = (name) => {
  if (!name) {
    return '';
  }

  const base = name
    .trim()
    .split(' ')
    .filter(
      (c) => !['de', 'da', 'do', 'das', 'dos', 'e'].includes(c.toLowerCase())
    );

  const namesWithoutAbbreviations = base.filter(
    (c) => !abbreviations.includes(c)
  );

  const abbreviation = base.find((c) => abbreviations.includes(c));

  const firstName = namesWithoutAbbreviations.slice(0, 1).join(' ');
  const lastName =
    namesWithoutAbbreviations.length > 1
      ? namesWithoutAbbreviations.slice(-1).join(' ')
      : null;

  return [abbreviation, firstName, lastName].filter((c) => !!c).join(' ');
};

export default reducerName;
